import { ChevronLeftIcon } from '@heroicons/react/solid'
import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

export const Card = ({ 
  title, 
  children,
  status = null,  
  onBack = () => {},
  enableBack = true,
  autoHeight = false 
}) => {
  const navigate = useNavigate()
  const { isLoggedIn, loginError } = useSelector(state => state.auth)    

  const handleBack = () => {
    try {
      navigate(-1)
      onBack()
    } catch (error) {
      if(isLoggedIn) {
        navigate('/user-dashboard')
      } else {
        navigate('/home')
      }

      onBack()
    }
  }

  return (
    <div className="flex flex-col w-full px-2 lg:px-10">        
        <div 
          className="bg-an_white border border-an_green w-full rounded overflow-hidden" 
        >
          {
            title &&
              <div className="flex p-2 w-full justify-between items-center bg-an_green-dark">
                {
                  enableBack ? 
                    <button 
                      className="w-12 h-6 text-an_white"
                      onClick={() => handleBack() }
                    >
                      <ChevronLeftIcon className="w-6" />
                    </button>
                  : <button className="w-12 h-6"></button>
                }
                <h5 className="text-md text-center truncate text-an_white">
                  { title }
                </h5>
                <div className="w-12 h-6 flex justify-end">
                  { status }
                </div>
              </div>
          }
          <div
            style={{height: autoHeight ? 'auto' : 'calc(100vh - 168px)'}}
            className="overflow-y-auto bg-an_white-light"
          >
            { children }
          </div>
        </div>
    </div>
  )
}